export default __webpack_public_path__ + "static/media/043-spyglass.7d7ed456.png";